import { NOTIFICATION_CAMPAIGN_ACTIONS, NOTIFICATION_CREATE_CAMPAIGN } from '../../config/notifications';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { hideNotification } from '../../store/actions/notification';
import DashboardLayout from '../layout/Dashboard';
import { Messages } from "../../components/layout/Messages/Messages";
import { ACL } from '../../config/constants';
import { NoRights } from '../../components/layout/Permissions/NoRights';
import { CampaignTable } from "../../components/pages/campaignManagement/CampaignTable";
import { CreateCampaign } from "../../components/pages/campaignManagement/actionButtons/CreateCampaign";
import {
  PageHeader,
  PageSurface,
  PageWorkspace
} from '../../components/layout/Workspace';
import './CampaignManagement.scss';

function ListCampaignComponent(props) {

  return (
    <DashboardLayout
      pageTitle={<FormattedMessage id="app.dashboard.page_title" />}
      workspace
      {...props}
    >
      <PageWorkspace className="campaigns-list-workspace">
        <PageHeader
          actions={<CreateCampaign/>}
          title={<FormattedMessage id="pages.campaignManagement.title" />}
        />
        <div className="campaigns-list-notifications">
          <Messages/>
          <Messages notificationId={ NOTIFICATION_CAMPAIGN_ACTIONS }/>
          <Messages notificationId={ NOTIFICATION_CREATE_CAMPAIGN }/>
        </div>
        <PageSurface className="campaigns-list-surface">
          { ACL.CLIENT.CAMPAIGNS.LIST.hasAccess() ? <CampaignTable/> : <NoRights/> }
        </PageSurface>
      </PageWorkspace>
    </DashboardLayout>
  )
}

const CampaignManagement = connect(null, { hideNotification })(ListCampaignComponent);

export { CampaignManagement, ListCampaignComponent };
